import { Route } from '@angular/router';
import { ChangePasswordPageService } from './change-password-page.service';

export const changePasswordPageRouteConfig: Route = {
  path: 'change-password',
  loadComponent: () => import('./change-password-page.component').then((c) => c.ChangePasswordPageComponent),
  providers: [ChangePasswordPageService]
};
